export default defineNuxtRouteMiddleware((to, from) => {
  // console.log("to", to);
  // console.log("from", from);

  if (to.name === "current-offers") {
    return navigateTo("/campaigns/see-homes/", { redirectCode: 302 });
  }
});
